import { render, staticRenderFns } from "./ServiceCategoryPage.vue?vue&type=template&id=ed43edf0&scoped=true&"
import script from "./ServiceCategoryPage.vue?vue&type=script&lang=js&"
export * from "./ServiceCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCategoryPage.vue?vue&type=style&index=0&id=ed43edf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed43edf0",
  null
  
)

export default component.exports